/**
 * Builds a new instance of the Body component.
 * @module Body
 * @constructor
 */

/** @lends module:Body */
function Body (scope, util, element, params) {
    var that = this;
    var resizeTimer;
    that.attribute = 'data-stry-body';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> Body -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> Body -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> Body -> No element available.'); return; }
        if (!params) { console.error('StoryStream -> Body -> No params provided.'); return; }

    }
    /*  End  */

    that.elem = element;
    that.prev_offset_y = 0;


    /**
     * Funnel all events through this method and distribute.
     * @memberof Body
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e) {
        var type = e.type ? e.type : e.name;
        switch(type) {
            case 'click':
            case 'touchend':

                //  Don't fire both 'touchend' and 'click' events
                if (scope.viewport && scope.viewport.is_touch && type === 'touchend' ||
                    scope.viewport && !scope.viewport.is_touch && type === 'click') {

                    //  Filter data actions
                    if (e.target.hasAttribute('data-stry-action')) {

                        //  Custom click event
                        STRY.util.transmit(scope, 'viewport.click', {
                            'e': e,
                            'action': e.target.getAttribute('data-stry-action')
                        });
                    }

                    //  Fire custom events if the attribute is present
                    if (e.target.hasAttribute('data-evt-track') &&
                        e.target.getAttribute('data-evt-track').length) {

                        STRY.analytics.track(e.target.getAttribute('data-evt-track'));
                    }
                }


                //
                // //  Indicate that the document has been clicked without a selected action.
                // else if (!e.target.hasAttribute('data-stry-action')) {
                //
                //     //  Custom click event
                //     STRY.util.transmit(scope, 'viewport.click', {
                //         'e': e,
                //         'action': 'click.document'
                //     });
                // }

                break;
            case 'scroll':

                willTransmitScrollEvent(e);

                break;
            case 'resize':

                //  Throttle for resize event
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {

                    willTransmitViewportEvent(e);

                }, 250);

                break;
            case 'view.scroll.disable':

                //  Disable scrolling
                util.addClass(that.elem, 'no-scroll');

                break;
            case 'view.scroll.enable':

                //  Enable scrolling
                util.removeClass(that.elem, 'no-scroll');

                break;
        }
    };


    /**
     * Function to handle 'viewport.scroll' events.
     * @memberof willTransmitScrollEvent
     * @function init
     * @param {object} e - Scroll event data.
     * @inner
     */
    var willTransmitScrollEvent = function (e) {

        //  Wait until browser is ready to do new paint work on the screen
        window.requestAnimationFrame(function () {

            //  Calculate header offset height ready to send with scroll event
            var header_elem = that.elem.getElementsByClassName('header')[0];
            var header_offset_height = header_elem ? header_elem.getBoundingClientRect().height : 0;
            var offset_y = window.pageYOffset || document.documentElement.scrollTop;

            //  Emit scroll event
            STRY.util.transmit(scope, 'viewport.scroll', {
                e : e ? e : {},
                offset_y : offset_y,
                offset_header: header_offset_height,
                dir: offset_y > that.prev_offset_y ? 'down' : 'up'
            });

            //  Store for determining scroll direction
            that.prev_offset_y = offset_y;
        });
    };


    /**
     * Function to handle 'viewport.change' events.
     * @memberof willTransmitViewportEvent
     * @function init
     * @param {object} e - Resize event data.
     * @inner
     */
    var willTransmitViewportEvent = function (e) {

        // Run code here, resizing has "stopped"
        window.requestAnimationFrame(function () {
            STRY.util.transmit(scope, 'viewport.change', {
                'e': e,
                'viewport': {
                    'height': e.target.innerHeight || 0,
                    'width': e.target.innerWidth || 0
                },
                'window': e.target
            });
        });
    };


    /**
     * Function used to initialise the application.
     * @memberof Body
     * @function init
     * @inner
     */
    var init = function () {

        //  Initialise smooth scrolling for anchor linking to elements
        var scroll = new SmoothScroll('a[href*="#"]', {
            header: '.header',
            speed: 500
        });

        //  Force a scroll event on load for dynamic position components that need it
        willTransmitScrollEvent();

        //  Force a viewport change event on load for dynamic position components that need it
        willTransmitViewportEvent({
            target: {
                innerHeight: window.innerHeight || 0,
                innerWidth: window.innerWidth || 0
            }
        });

        //  Listen for all click events
        that.elem.addEventListener("click", handleEvent, {passive: false});
        that.elem.addEventListener("touchend", handleEvent, {passive: false});
        window.addEventListener("scroll", handleEvent, false);
        window.addEventListener("resize", handleEvent, false);
        scope.addEventListener("view.scroll.disable", handleEvent, false);
        scope.addEventListener("view.scroll.enable", handleEvent, false);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.Body = Body;
}
